/**
 * iOS-Settings inspired row — label left, control snapped right. Hint
 * text appears under the label when present. Layout primitive only;
 * the control owns its own validation + state.
 */
export function SettingsRow({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex min-w-0 flex-col">
        <span className="text-sm font-medium text-wx-fg">{label}</span>
        {hint && <span className="text-[11px] text-wx-fg-muted">{hint}</span>}
      </div>
      <div className="shrink-0">{children}</div>
    </div>
  );
}
